import React, { useState } from 'react';
import {
    Box,
    Button,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';

// import DataTable from '../../../components/ReportsMemberActivity/DataTable';
import ProjectReportTable from './report-project-table/ProjectReportTable';
import DateActivityTable from '../../../components/ReportsDateActivity/DateActivityTable';
import MonthlyBarChart from '../MonthlyBarChart';
import DailyTotalReportTable from './DailyTotalReportTable';
import DailyTotalProjectTable from './DailyTotalProjectTable';





import DataTable from './DataTable';
import WidgetsDropdown from '../../../layout/WidgetsDropdown';



import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';


import StatsCardRow from './StatsCardRow';
import ShareReport from '../../../components/Projects/ShareReport';
import ScheduleReport from '../../../components/Projects/ScheduleReport';

import ReportFilter from './ReportFilter';

import ExportFile from './ExportFile';
import AppUsageBarChart from './AppUsageBarChart';
import MemberUsageBarChart from '../../../components/chart/MemberUsageBarChart';

const projects = [
    {
        name: 'Vansh Saini',
        role: 'Social Media Strategist',
        avatar: 'https://i.pravatar.cc/150?img=1',
        color: '#6A1B9A',
        time: '6:18:00',
        mon: '9:11:01',
        tue: '9:11:01',
        wed: '-',
        thu: '9:11:01',
        fri: '9:11:01',
        sat: '-',
        sun: '-',
        amount: '$ 346.50',
        activity: '50'
    },
    {
        name: 'Jenny Wilson',
        role: 'Content Marketing Manager',
        avatar: 'https://i.pravatar.cc/150?img=2',
        color: '#9C5959',
        time: '6:18:00',
        mon: '9:11:01',
        tue: '9:11:01',
        wed: '-',
        thu: '9:11:01',
        fri: '9:11:01',
        sat: '-',
        sun: '-',
        amount: '$ 346.50',
        activity: '20'
    },

    {
        name: 'Dianne Russell',
        role: 'SEO Specialist',
        avatar: 'https://i.pravatar.cc/150?img=3',
        color: '#00831E',
        time: '6:18:00',
        mon: '9:11:01',
        tue: '9:11:01',
        wed: '-',
        thu: '9:11:01',
        fri: '9:11:01',
        sat: '-',
        sun: '-',
        amount: '$ 346.50',
        activity: '80'
    },
];






function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const DailyTotalsReport = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0); // Tab value
    const [anchorEl, setAnchorEl] = useState(null); // Menu anchor
    const [selectedOption, setSelectedOption] = useState('Date'); // Organize by

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const statsData = [
        { label: 'Members Worked', value: '20' },
        { label: 'Total Worked Time', value: '290:47:30', color: '#179045' },
        { label: 'Avg. Hours Per Member', value: '9:13:29', },
        { label: 'Avg. Activity', value: '49%' },
        { label: 'Amount Spent', value: '$1,638.53', color: '#0076FE' },

    ];
    const [openShareReport, setOpenShareReport] = useState(false);
    const [openScheduleReport, setOpenScheduleReport] = useState(false);

    return (
        <>
            <Box>
                <Button
                    onClick={() => navigate('/reports')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        fontFamily: 'Manrope',
                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Reports
                </Button>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="600" sx={{ fontFamily: 'Manrope', }}>
                    Daily totals report (Weekly)
                </Typography>
                <Box className="d-flex gap-10 align-items-center">

                    {/* Widgets & Scheduled Button */}
                    <WidgetsDropdown
                        widgetOptions={[
                            'Member',
                            'Info',
                            'Employment',
                            'Project',
                            'Time',
                            'Activity',
                            'Manual hours',
                            'Idle (%)',
                            'Idle (hr)',
                            'Spent',
                            'Notes',
                        ]}
                        defaultSelected={[
                            'Employment',
                            'Project',
                            'Time',
                            'Activity',
                            'Manual hours',
                            'Idle (%)',
                        ]}
                    />



                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '30px',
                            textTransform: 'capitalize',
                            fontSize: '16px',
                            padding: '8px 16px',
                            background: '#0076FE',
                            fontFamily: 'Manrope',
                            height: '36px',
                            border: 'none',
                            boxShadow: 'none'
                        }}
                        onClick={() => navigate('/scheduled-reports')}
                    >
                        Scheduled reports
                    </Button>

                </Box>
            </Box>


            {/* Tabs */}
            <Box sx={{ borderColor: 'divider', display: 'inline-block' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '8px' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Me" {...a11yProps(0)} />
                        <Tab label="All" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </Box>
            <Box className="mt-24" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', }}>
                {/* <DateRangePicker />  */}
                <SingleDatePicker />

                <Box display='flex' alignItems='center' sx={{ gap: '14px' }}>
                    <ReportFilter />
                    <Button onClick={() => setOpenShareReport(true)} display='flex' alignItems='center' sx={{
                        gap: '10px', fontFamily: 'Manrope', background: '#FFFFFF', borderRadius: '100px', color: '#64748B', fontSize: '14px', textTransform: 'Uppercase', fontWeight: '500', height: '36px', border: 'none', padding: '8px 16px', border: '1px solid #E5E8EB', '&:hover': {
                            background: '#0076FE',
                            borderColor: '0076FE',
                            color: '#fff'
                        }
                    }}><FileUploadOutlinedIcon sx={{ fontSize: '18px' }} />Share</Button>
                    <Button onClick={() => setOpenScheduleReport(true)} display='flex' alignItems='center' sx={{
                        gap: '10px', fontFamily: 'Manrope', background: '#FFFFFF', borderRadius: '100px', color: '#64748B', fontSize: '14px', textTransform: 'Uppercase', fontWeight: '500', height: '36px', border: 'none', padding: '8px 16px', border: '1px solid #E5E8EB', '&:hover': {
                            background: '#0076FE',
                            borderColor: '0076FE',
                            color: '#fff'
                        }
                    }}><AccessTimeIcon sx={{ fontSize: '18px' }} />Schedule</Button>

                    <ExportFile />
                    <ShareReport open={openShareReport} onClose={() => setOpenShareReport(false)} />
                    <ScheduleReport open={openScheduleReport} onClose={() => setOpenScheduleReport(false)} />
                </Box>
            </Box>



            <Box sx={{ margin: '18px auto 0' }}>
                <div className="row">
                    <div><StatsCardRow stats={statsData} /></div>
                </div>
            </Box>


            {/* Me Tab */}
            <CustomTabPanel value={value} index={0}>
                <Box className="mt-24">
                    <Box className="card-body p-20 bg-base border rounded-3 mt-24">
                        <MonthlyBarChart />
                    </Box>
                    <DailyTotalProjectTable projects={projects} /> 
                </Box>
            </CustomTabPanel>

            {/* All Tab */}
            <CustomTabPanel value={value} index={1}>
                <Box className="mt-24">
                    <Box className="card-body p-20 bg-base border rounded-3">
                        <Typography sx={{ fontSize: '17px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 24px', fontFamily: 'Manrope' }}>Hours spent per apps</Typography>
                        <MemberUsageBarChart />
                    </Box>
                    <DailyTotalReportTable projects={projects} />
                </Box>

            </CustomTabPanel>
        </>
    );
};

export default DailyTotalsReport;
